import { Extension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import Placeholder from '@tiptap/extension-placeholder';
import CharacterCount from '@tiptap/extension-character-count';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import ListItem from '@tiptap/extension-list-item';
import Blockquote from '@tiptap/extension-blockquote';
import { BlockIds } from '@/components/writer/extensions/blockIds.js';
import { ComponentBlocks } from '@/components/writer/extensions/blocks.js';
import { SlashCommands } from '@/components/writer/extensions/slash.js';

/** Hands the component views what they need from the page around them. */
const WriterContext = Extension.create({
  name: 'writerContext',
  addOptions: () => ({ search: null, uploadImage: null }),
  addStorage() {
    return { search: this.options.search, uploadImage: this.options.uploadImage };
  },
});

/**
 * The editor's schema. It may only make what the server's DocumentSchema takes
 * and the iOS reader can draw, so anything pasted in is reduced to these.
 */
export function writerExtensions({ search, uploadImage }) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      code: false,
      codeBlock: false,
      horizontalRule: false,
      listItem: false,
      blockquote: false,
    }),
    ListItem.extend({ content: 'paragraph (paragraph | bulletList | orderedList)*' }),
    Blockquote.extend({ content: 'paragraph+' }),
    Underline,
    Highlight,
    Link.configure({ openOnClick: false, autolink: true, protocols: ['http', 'https', 'mailto'], HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' } }),
    TextAlign.configure({ types: ['heading', 'paragraph'], alignments: ['left', 'center', 'right', 'justify'] }),
    Placeholder.configure({ placeholder: 'Write, or type / for components', includeChildren: true, showOnlyCurrent: false }),
    CharacterCount,
    Table.configure({ resizable: false }),
    TableRow,
    TableHeader.extend({ content: 'paragraph+' }),
    TableCell.extend({ content: 'paragraph+' }),
    BlockIds,
    SlashCommands,
    WriterContext.configure({ search, uploadImage }),
    ...ComponentBlocks,
  ];
}
